import Fuse from "fuse.js";

export const findClosestMatch = ({ array, inputName, keys = ["name"], threshold = 0.3, distance = 100 }) => {
  const fuse = new Fuse(array, {
    keys,
    threshold,
    distance,
  });

  const result = fuse.search(inputName);

  if (result.length > 0) {
    return result[0].item;
  } else {
    return null; // No close match found
  }
};
